// 判断数据不为空（空对象、空数组、null、undefined、''、空格、'0'、0、0.0、0.00...）

export function inObj(a, b) {
	if (!a) {
		return false
	}
	if (JSON.stringify(a).includes(JSON.stringify(b))) {
		return true
	} else {
		return false
	}
}
export function notEmpty(val) {
	let bool = false
	if (typeof val=='object') {
	   bool = !inObj(['{}','[]','null'],val)
	}else{
		const regex = /^($|""| |0(\.0+)?|undefined)$/;
		bool = !regex.test(val)
	}
	return bool;
}


// 将对象转为get参数
export function converToUrl(request) {
	let params = [];
	Object.entries(request).forEach(([key, value]) => {
		if (Array.isArray(value)) {
			for (let i in value) {
				let param = key + '=' + value[i]
				params.push(param);
			}
		} else {
			let param = key + '=' + value;
			params.push(param);
		}
	});
	return params.join('&') || '';
}



//////////////////
// WEBPACK FOOTER
// ./static/all.js
// module id = i9qw
// module chunks = 1